import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { useData } from '../../contexts/DataContext';
import { ProductCard } from '../ProductCard';
export function ProductBrowser() {
  const {
    products,
    categories
  } = useData();
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const filteredProducts = products.filter(product => {
    const matchesCategory = activeCategory === 'All' || product.category === activeCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <div className="space-y-8" data-id="element-1094">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1095">
        <div className="flex overflow-x-auto pb-2 md:pb-0 gap-2 w-full md:w-auto no-scrollbar" data-id="element-1096">
          <button onClick={() => setActiveCategory('All')} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === 'All' ? 'bg-rose-500 text-white shadow-md' : 'bg-white text-gray-600 hover:bg-rose-50'}`} data-id="element-1097">
            All Products
          </button>
          {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.title)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === category.title ? 'bg-rose-500 text-white shadow-md' : 'bg-white text-gray-600 hover:bg-rose-50'}`} data-id="element-1098">
              {category.title}
            </button>)}
        </div>

        <div className="relative w-full md:w-64" data-id="element-1099">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-1100" />
          <input type="text" placeholder="Search products..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-500 text-sm" data-id="element-1101" />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1102">
        {filteredProducts.map(product => <ProductCard key={product.id} product={product} name={product.name} price={product.price} image={product.image} category={product.category} isNew={product.isNew} data-id="element-1103" />)}
      </div>

      {filteredProducts.length === 0 && <div className="text-center py-12" data-id="element-1104">
          <p className="text-gray-500" data-id="element-1105">
            No products found matching your criteria.
          </p>
        </div>}
    </div>;
}